<h1 mat-dialog-title>Search by ID</h1>

<div mat-dialog-content>
  <mat-form-field>
    <input
      type="text"
      matInput
      placeholder="U000001, D000021..."
      [autocomplete]="false"
      [(ngModel)]="value" />
  </mat-form-field>
</div>

@if (error) {
<p class="form-error-msg">{{ error }}</p>
}

<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true">Close</button>
  <button mat-button [disabled]="!value" (click)="submit()">Search</button>
</div>
